import PropTypes from "prop-types";
import React from "react";

import { ListMatrix } from "@swa-ui/core";
import { PlacementFactory } from "@swa-ui/placements";

import { SPECIAL_OFFER_1, SPECIAL_OFFERS } from "../../defines/specialOffersLayoutType";
import styles from "./SpecialOffersCard.module.scss";

const PLACEMENT_COUNT = 1;

export const SpecialOffersCard = (props) => {
  const { placementIds } = props;
  const layoutType = placementIds.length === PLACEMENT_COUNT ? SPECIAL_OFFER_1 : SPECIAL_OFFERS;

  return <ListMatrix {...getListMatrixProps()} />;

  function getListMatrixProps() {
    return {
      center: true,
      itemClassName: styles.listRow,
      items: placementIds.map((placementId) => ({
        content: renderSpecialOfferPlacement(placementId),
      })),
      numberOfColumns: placementIds.length,
    };
  }

  function renderSpecialOfferPlacement(placementId) {
    return (
      <PlacementFactory
        additionalProps={{ layoutType }}
        className={styles.specialOffersPlacementContainer}
        id={placementId}
      />
    );
  }
};

SpecialOffersCard.propTypes = {
  /** Array of placement id's. */
  placementIds: PropTypes.array.isRequired,
};
